import React from 'react'
import Slider from 'react-slick';
import Plan_bg from "../images/Plan_Bg.webp"
import Amazonprime from '../images/prime.webp'
import Sonylive from '../images/sonylive.webp'
import Disneyhotstar from '../images/disney.webp'
import Historych from '../images/history.webp'

export const Entertainment = () => {
    var settings3 = {
        dots: false,
        navigation: true,
        loop: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        speed: 300,
        autoplaySpeed: 3000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1340,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      };
  return (
    <>
    <div className='planslider'>
                        <Slider {...settings3}>
                          <div>
                            <div className='plansitem'>
                              <div className='ptag'>
                                <h5>Silver</h5>
                              </div>
                              <div className='image_plans_div'>
                                <div className="image_plan">
                                  <img src={Plan_bg} alt="plan" />
                                </div>
                                <p>150 <span>mbps</span></p>
                              </div>
                              <div className='price m-0'>
                                <div className='sprice m-0'>
                                  <h6>799</h6>
                                </div>
                              </div>
                              <div className='entertainment'>
                                <ul>
                                  <li><img src={Amazonprime} alt='Amazon Prime'/></li>
                                  <li><img src={Sonylive} alt='Sony Live'/></li>
                                  <li><img src={Disneyhotstar} alt='Disney Hotstar'/></li>
                                  <li><img src={Historych} alt='History'/></li>
                                </ul>
                              </div>
                              <div className='price'>
                                <ul>
                                  <li>10 OTT Apps</li>
                                  <li>Unlimited Data</li>
                                  <li>Unlimited Calls</li>
                                  <li>1 Month Validity</li>
                                </ul>
                                <div className='buttnprop'>
                                  <span>Book Now</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className='plansitem'>
                              <div className='ptag'>
                                <h5>Silver Pro</h5>
                              </div>
                              <div className='image_plans_div'>
                                <div className="image_plan">
                                  <img src={Plan_bg} alt="plan" />
                                </div>
                                <p>400 <span>mbps</span></p>
                              </div>
                              <div className='price m-0'>
                                <div className='sprice m-0'>
                                  <h6>999</h6>
                                </div>
                              </div>
                              <div className='entertainment'>
                                <ul>
                                  <li><img src={Amazonprime} alt='Amazon Prime'/></li>
                                  <li><img src={Sonylive} alt='Sony Live'/></li>
                                  <li><img src={Disneyhotstar} alt='Disney Hotstar'/></li>
                                  <li><img src={Historych} alt='History'/></li>
                                </ul>
                              </div>
                              <div className='price'>
                                <ul>
                                  <li>14 OTT Apps</li>
                                  <li>Unlimited Data</li>
                                  <li>Unlimited Calls</li>
                                  <li>1 Month Validity</li>
                                </ul>
                                <div className='buttnprop'>
                                  <span>Book Now</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className='plansitem'>
                              <div className='ptag'>
                                <h5>Gold</h5>
                              </div>
                              <div className='image_plans_div'>
                                <div className="image_plan">
                                  <img src={Plan_bg} alt="plan" />
                                </div>
                                <p>500 <span>mbps</span></p>
                              </div>
                              <div className='price m-0'>
                                <div className='sprice m-0'>
                                  <h6>1299</h6>
                                </div>
                              </div>
                              <div className='entertainment'>
                                <ul>
                                  <li><img src={Amazonprime} alt='Amazon Prime'/></li>
                                  <li><img src={Sonylive} alt='Sony Live'/></li>
                                  <li><img src={Disneyhotstar} alt='Disney Hotstar'/></li>
                                  <li><img src={Historych} alt='History'/></li>
                                </ul>
                              </div>
                              <div className='price'>
                                <ul>
                                 <li>14 OTT Apps</li>
                                  <li>Unlimited Data</li>
                                  <li>Unlimited Calls</li>
                                  <li>1 Month Validity</li>
                                </ul>
                                <div className='buttnprop'>
                                  <span>Book Now</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className='plansitem'>
                              <div className='ptag'>
                                <h5>Gold pro</h5>
                              </div>
                              <div className='image_plans_div'>
                                <div className="image_plan">
                                  <img src={Plan_bg} alt="plan" />
                                </div>
                                <p>600 <span>mbps</span></p>
                              </div>
                              <div className='price m-0'>
                                <div className='sprice m-0'>
                                  <h6>1499</h6>
                                </div>
                              </div>
                              <div className='entertainment'>
                                <ul>
                                  <li><img src={Amazonprime} alt='Amazon Prime'/></li>
                                  <li><img src={Sonylive} alt='Sony Live'/></li>
                                  <li><img src={Disneyhotstar} alt='Disney Hotstar'/></li>
                                  <li><img src={Historych} alt='History'/></li>
                                </ul>
                              </div>
                              <div className='price'>
                                <ul>
                                  <li>14 OTT Apps</li>
                                  <li>Unlimited Data</li>
                                  <li>Unlimited Calls</li>
                                  <li>1 Month Validity</li>
                                </ul>
                                <div className='buttnprop'>
                                  <span>Book Now</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className='plansitem'>
                              <div className='ptag'>
                                <h5>Platinum</h5>
                              </div>
                              <div className='image_plans_div'>
                                <div className="image_plan">
                                  <img src={Plan_bg} alt="plan" />
                                </div>
                                <p>1000 <span>mbps</span></p>
                              </div>
                              <div className='price m-0'>
                                <div className='sprice m-0'>
                                  <h6>3999</h6>
                                </div>
                              </div>
                              <div className='entertainment'>
                                <ul>
                                  <li><img src={Amazonprime} alt='Amazon Prime'/></li>
                                  <li><img src={Sonylive} alt='Sony Live'/></li>
                                  <li><img src={Disneyhotstar} alt='Disney Hotstar'/></li>
                                  <li><img src={Historych} alt='History'/></li>
                                </ul>
                              </div>
                              <div className='price'>
                                <ul>
                                  <li>14 OTT Apps</li>
                                  <li>Unlimited Data</li>
                                  <li>Unlimited Calls</li>
                                  <li>1 Month Validity</li>
                                </ul>
                                <div className='buttnprop'>
                                  <span>Book Now</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Slider>
                      </div>
    </>
  )
}
